/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { useFormik } from 'formik'
import { useEffect, useRef, useState } from 'react'
import { Modal } from 'react-bootstrap'
import { createPortal } from 'react-dom'
import { toast } from 'react-toastify'
import * as Yup from 'yup'
import { StepperComponent } from '../../../../_metronic/assets/ts/components'
import { KTSVG } from '../../../../_metronic/helpers'
import { useCreateOrganizationWorkflowMutation, useGetOrganizationAllRolesQuery } from '../../../../services/OrganizationApi'
import { Step1 } from './steps/Step1'
import labelKey from "../../../localization/label.json"
import tosterKey from "../../../localization/toster.json"
import { useAppSelector } from '../../../../hooks'
import { useDepartmentsLookupQuery, useGetAllCityQuery, useGetAllCountryQuery, useGetAllDivisionQuery, useGetAllLocationTypeQuery, useGetAllLocationsQuery, useGetAllLst_UserExpenseTypeQuery, useGetAllOrganizationLookUpQuery } from '../../../../services/GeneralApi'
import { useCreateUserMutation, useGetAllManagerQuery, useUpdateUserMutation } from '../../../../services/authApi'
import { constraintConfig } from '../../../../constraintConfig'
import axios from 'axios'
import { selectAuth } from '../../../../features/authSlice'
import { baseUrl } from '../../../../services/baseUrl'
import { Step2 } from './steps/Step2'
import { Step3 } from './steps/Step3'
import { Step4 } from './steps/Step4'
import { API_END_POINTS } from '../../../../services/apiEndpoints'

type Props = {
  show: boolean
  handleClose: () => void
  data: any
}

const modalsRoot = document.getElementById('root-modals') || document.body

const initialValues = {
  active: true,
  orgId: 0,
  role: {
    roleID: 0,
    name: ''
  },
  expenseType: {
    id: '',
    value: ''
  },
  locationType: {
    id: 0,
    value: ''
  },
  location: {
    id: 0,
    value: ''
  },
  userAccountID: 0,
  employeeId: '',
  firstName: '',
  middleName: '',
  lastName: '',
  cellPhone: '',
  businessPhone: '',
  businessExt: '',
  email: '',
  mgrApproveMaxLimit: 0,
  department: {
    id: 0,
    title: ''
  },
  designation: {
    id: 0,
    title: ''
  },
  division: {
    id: 0,
    title: ''
  },
  userRole: {
    fk_UserAccountID: 0,
    roleID: 0,
    roleName: ''
  },
  userOrg: {
    userInOrgId: 0,
    userInOrgName: ''
  },
  managerId: 0,
  managerName: '',
  country: {
    id: 0,
    title: ''
  },
  // city: {
  //   id: 0,
  //   title: ''
  // },
  city: '',
  addressLine1: '',
  addressLine2: '',
  state: '',
  postalCode: '',
  latitude: '',
  longitude: '',
  findAddress: '',
  bcEmployeeId: '',
  reportPermision: false,
  userTimeZone: {
    id: 0,
    title: ''
  },
}
const UpdateUserModal = ({ show, handleClose, data }: Props) => {

  const stepperRef = useRef<HTMLDivElement | null>(null)
  const stepper = useRef<StepperComponent | null>(null)
  const loadStepper = () => {
    stepper.current = StepperComponent.createInsance(stepperRef.current as HTMLDivElement)
  }


  const { userInOrgId, token, baseURL } = useAppSelector(selectAuth);
  const { data: getAllOrganizationLookUp, refetch: orgLookUpRefetch } = useGetAllOrganizationLookUpQuery('');
  const { data: getAllManger, refetch: ManagersRefetch } = useGetAllManagerQuery('');
  const { data: departmentLookup, refetch: departmentRefetch } = useDepartmentsLookupQuery('');
  // const { data: designationLookup } = useDesignationLookupQuery(formik.values.role.roleID);
  const { data: getAllRolesData, refetch: rolesRefetch } = useGetOrganizationAllRolesQuery('');
  const [updateUser, { isSuccess: updateIsSuccess, isError, error, isLoading: updateIsLoading }] = useUpdateUserMutation()

  const { data: getAllExpenseType } = useGetAllLst_UserExpenseTypeQuery('')
  const { data: getAllLocationType } = useGetAllLocationTypeQuery('')
  const { data: locationsData, refetch: locationRefetch } = useGetAllLocationsQuery('')
  const { data: getAllCites, refetch: citiesRefetch } = useGetAllCityQuery('')
  const { data: getAllcountries, refetch: countriesRefetch } = useGetAllCountryQuery('')
  const { data: getAlldivision, refetch: divisionRefetch } = useGetAllDivisionQuery('')

  const [id, setId] = useState(0);
  const [formValues, setFormValues] = useState(initialValues);



  useEffect(() => {
    if (show) {
      orgLookUpRefetch()
      ManagersRefetch()
      departmentRefetch()
      locationRefetch()
      rolesRefetch()
      citiesRefetch()
      countriesRefetch()
      divisionRefetch()
    }
  }, [show, orgLookUpRefetch, ManagersRefetch, departmentRefetch, locationRefetch, rolesRefetch, citiesRefetch, countriesRefetch, divisionRefetch])


  const handleModalClose = () => {
    setFormValues(formik.values);
    handleClose();
  };
  useEffect(() => {
    // Restore form values when the modal reopens
    if (show && !data && Object.keys(formValues).length !== 0) {
      formik.setValues(formValues);
    }
    // Update form values based on data received
    if (data) {
      setId(data?.userAccountID);
      formik.setValues({
        ...data,
        orgId: data?.userOrg?.userInOrgId,
        userRole: {
          fk_UserAccountID: data?.userAccountID,
          roleID: data.userRole?.roleID,
          roleName: data.userRole?.roleName
        }
      })
    } else if (!show) {
      // Reset form values only when closing and it's not an update action
      setId(0);
      formik.resetForm();
    }
  }, [show, data]);

  type InitialValuesType = typeof initialValues;

  const formik = useFormik({
    initialValues,
    // validationSchema: validationSchema,
    onSubmit: (values, { resetForm }) => {
      // const orgId = values?.userOrg?.userInOrgId
      // if (roleID === constraintConfig.roleID.role1 || roleID === constraintConfig.roleID.role2) {
      //   if (String(values.userRole?.roleID) === String(constraintConfig.roleID?.role5) && !values.managerId) {
      //     toast.error(tosterKey.managerIsRequired);
      //   }
      //   else {
      //     updateContact(values)
      //   }
      // }
      // else {
      //   updateContact(values)
      // }
      updateUser(values)

      // const filterInitialValues = (values: InitialValuesType, initialValues: InitialValuesType) => {
      //   // Explicitly typing filteredValues as Partial<InitialValuesType>
      //   const filteredValues: Partial<InitialValuesType> = {};

      //   // Iterate through the keys of initialValues using keyof InitialValuesType
      //   (Object.keys(initialValues) as Array<keyof InitialValuesType>).forEach((key) => {
      //     // Copy the values that match the initial keys
      //     if (values[key] !== undefined) {
      //       filteredValues[key] = values[key] as any;
      //     }
      //   });

      //   return filteredValues;
      // };

      // // Filter the values to match only the initial values
      // const filteredPayload = filterInitialValues(values, initialValues);

      // // Pass the filtered payload to your update function
      // updateUser(filteredPayload);
    },
  })

  useEffect(() => {
    if (updateIsSuccess) {
      toast.success(tosterKey.userUpdatedSuccessfully);
      handleClose()
    }
  }, [updateIsSuccess]);

  useEffect(() => {
    if (isError && error) {
      let errorMessage: string = 'Something went wrong';

      if ('data' in error && error.data && typeof error.data === 'object' && 'message' in error.data) {
        errorMessage = (error.data as { message: string }).message;
      }
      toast.error(errorMessage);
    }
  }, [isError, error]);
  const [designationLookup, setDesignationLookup] = useState<any>(null);
  useEffect(() => {
    const fetchData = async () => {
      if (show && formik.values.userRole.roleID) {
        try {
          const headers = {
            Authorization: `Bearer ${token}`,
          };
          const getExpenseLogResponse = await axios.get(
            `${baseURL}/api/General${API_END_POINTS.getAllDesignation}?roleId=${formik?.values?.userRole?.roleID}`,
            {
              headers,
            }
          );
          const designationLookup = getExpenseLogResponse.data;
          setDesignationLookup(designationLookup);
        } catch (error) {
          console.error('Error fetching data:', error);
        }
      }
    };
    fetchData();
  }, [show, formik?.values?.userRole?.roleID, token]);

  const prevStep = () => {
    if (!stepper.current) {
      return
    }

    stepper.current.goPrev()
  }

  const nextStep = () => {
    if (!stepper.current) {
      return;
    }
    if (stepper.current.currentStepIndex === 1) {
      // Check if Step 1 fields are valid
      if (!formik.values?.userRole?.roleID) {
        toast.error(tosterKey.roleIsRequired);
        return;
      }
      else if (!formik.values?.expenseType?.id) {
        toast.error(tosterKey.allowedExpenseTypeIsRequired);
        return;
      }
      else if (!formik.values?.locationType?.id) {
        toast.error(tosterKey.allowedMileageTypeIsRequired);
        return;
      }
      else if (String(formik.values.userRole.roleID) === constraintConfig.roleID.role5.toString() && !formik.values.managerId) {
        toast.error(tosterKey.managerIsRequired);
        return;
      }
      else if (String(formik.values.userRole.roleID) === constraintConfig.roleID.role4.toString() && !formik.values.mgrApproveMaxLimit) {
        toast.error(tosterKey.approvalLimitIsRequired);
        return;
      }
      else if (!formik.values?.location?.id) {
        toast.error(tosterKey.locationIsRequired);
        return;
      }
    }

    else if (stepper.current.currentStepIndex === 2) {
      if (!formik.values?.email) {
        toast.error(tosterKey.emailIsRequired);
        return;
      } else if (!/^\S+@\S+\.\S+$/.test(formik.values.email)) {
        toast.error('Invalid email format');
        return;
      } else if (!formik.values?.employeeId) {
        toast.error(tosterKey.employeeIDIsRequired);
        return;
      } else if (formik.values.employeeId === '0') {
        toast.error('Employee ID should be a non-zero ');
        return;
      } else if (formik.values.employeeId.length > 12) {
        toast.error('Employee ID should not exceed 12 characters');
        return;
      } else if (formik.values.bcEmployeeId.length > 12) {
        toast.error('BC Employee ID should not exceed 12 characters');
        return;
      } else if (!formik.values?.firstName) {
        toast.error(tosterKey.firstNameIsRequired);
        return;
      } else if (!formik.values?.lastName) {
        toast.error(tosterKey.lastNameIsRequired);
        return;
      } else if (!formik.values?.userTimeZone?.id) {
        toast.error(tosterKey.timeZoneIsRequired);
        return;
      }

    }
    else if (stepper.current.currentStepIndex === 3) {
      if (!formik.values.findAddress) {
        toast.error(tosterKey.findAddress);
        return;
      }
    }

    stepper.current.goNext();
  };

  // const handleModalClose = () => {
  //   resetForm();
  //   handleClose();
  // };
  return createPortal(
    <Modal
      id='kt_modal_create_app'
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName='modal-dialog custom-modal-size modal-dialog-centered '
      show={show}
      onHide={handleModalClose}
      onEntered={loadStepper}
      backdrop="static"
    >
      <div className='modal-header'>
        <h2>{labelKey.updateExpenseUser} - ({data?.firstName} {data?.middleName} {data?.lastName})</h2>
        {/* begin::Close */}
        <div className='btn btn-sm btn-icon btn-active-color-primary' onClick={handleClose}>
          <KTSVG className='svg-icon-1' path='/media/icons/duotune/arrows/arr061.svg' />
        </div>
        {/* end::Close */}
      </div>

      <div className='modal-body py-lg-10 px-lg-10'>
        {/*begin::Stepper */}
        <div
          ref={stepperRef}
          className='stepper stepper-pills stepper-column d-flex flex-column flex-xl-row flex-row-fluid'
          id='kt_modal_create_app_stepper'
        >
          {/* begin::Aside*/}
          <div className='d-flex justify-content-center justify-content-xl-start flex-row-auto w-100 w-xl-300px'>
            {/* begin::Nav*/}
            <div className='stepper-nav ps-lg-10'>
              {/* begin::Step 1*/}
              <div className='stepper-item current' data-kt-stepper-element='nav'>
                {/* begin::Wrapper*/}
                <div className='stepper-wrapper'>
                  {/* begin::Icon*/}
                  <div className='stepper-icon w-40px h-40px'>
                    <i className='stepper-check fas fa-check'></i>
                    <span className='stepper-number'>1</span>
                  </div>
                  {/* end::Icon*/}

                  {/* begin::Label*/}
                  <div className='stepper-label'>
                    <h3 className='stepper-title'>{labelKey.userRole}</h3>
                    <div className='stepper-desc'>{labelKey.addUserRoleDetail}</div>
                  </div>
                  {/* end::Label*/}
                </div>
                {/* end::Wrapper*/}

                {/* begin::Line*/}
                <div className='stepper-line h-40px'></div>
                {/* end::Line*/}
              </div>
              {/* end::Step 1*/}

              {/* begin::Step 2*/}
              <div className='stepper-item' data-kt-stepper-element='nav'>
                {/* begin::Wrapper*/}
                <div className='stepper-wrapper'>
                  {/* begin::Icon*/}
                  <div className='stepper-icon w-40px h-40px'>
                    <i className='stepper-check fas fa-check'></i>
                    <span className='stepper-number'>2</span>
                  </div>
                  {/* begin::Icon*/}

                  {/* begin::Label*/}
                  <div className='stepper-label'>
                    <h3 className='stepper-title'>{labelKey.userDetails}</h3>
                    <div className='stepper-desc'>{labelKey.addUserDetail}</div>
                  </div>
                  {/* begin::Label*/}
                </div>
                {/* end::Wrapper*/}

                {/* begin::Line*/}
                <div className='stepper-line h-40px'></div>
                {/* end::Line*/}
              </div>
              {/* end::Step 2*/}

              {/* begin::Step 3*/}
              <div className='stepper-item' data-kt-stepper-element='nav'>
                {/* begin::Wrapper*/}
                <div className='stepper-wrapper'>
                  {/* begin::Icon*/}
                  <div className='stepper-icon w-40px h-40px'>
                    <i className='stepper-check fas fa-check'></i>
                    <span className='stepper-number'>3</span>
                  </div>
                  {/* end::Icon*/}

                  {/* begin::Label*/}
                  <div className='stepper-label'>
                    <h3 className='stepper-title'>{labelKey.userAddress}</h3>

                    <div className='stepper-desc'>{labelKey.addAddressDetail}</div>
                  </div>
                  {/* end::Label*/}
                </div>
                {/* end::Wrapper*/}

                {/* begin::Line*/}
                <div className='stepper-line h-40px'></div>
                {/* end::Line*/}
              </div>
              {/* end::Step 3*/}


              {/* begin::Step 5*/}
              <div className='stepper-item' data-kt-stepper-element='nav'>
                {/* begin::Wrapper*/}
                <div className='stepper-wrapper'>
                  {/* begin::Icon*/}
                  <div className='stepper-icon w-40px h-40px'>
                    <i className='stepper-check fas fa-check'></i>
                    <span className='stepper-number'>4</span>
                  </div>
                  {/* end::Icon*/}

                  {/* begin::Label*/}
                  <div className='stepper-label'>
                    <h3 className='stepper-title'>{labelKey.overview}</h3>

                    <div className='stepper-desc'>{labelKey.reviewAndSubmit}</div>
                  </div>
                  {/* end::Label*/}
                </div>
                {/* end::Wrapper*/}
              </div>
              {/* end::Step 5*/}
            </div>
            {/* end::Nav*/}
          </div>
          {/* begin::Aside*/}

          {/*begin::Content */}
          <div className='flex-row-fluid py-lg-5 px-lg-15'>
            {/*begin::Form */}
            <form noValidate id='kt_modal_create_app_form' onSubmit={formik.handleSubmit}>
              <Step1 formik={formik}
                getAllOrganizationLookUp={getAllOrganizationLookUp}
                getAllRolesData={getAllRolesData}
                getAllExpenseType={getAllExpenseType}
                getAllManger={getAllManger}
                departmentLookup={departmentLookup}
                designationLookup={designationLookup}
                getAllLocationType={getAllLocationType}
                locationsData={locationsData}
                getAlldivision={getAlldivision}
              />
              <Step2 formik={formik} />
              <Step3 formik={formik}
                getAllCites={getAllCites}
                getAllcountries={getAllcountries} />
              <Step4 formik={formik}
                getAllRolesData={getAllRolesData} />

              {/*begin::Actions */}
              <div className='d-flex flex-stack pt-10'>
                <div className='me-2'>
                  <button
                    type='button'
                    className='btn btn-lg btn-light-primary me-3'
                    data-kt-stepper-action='previous'
                    onClick={prevStep}
                  >
                    <KTSVG
                      path='/media/icons/duotune/arrows/arr063.svg'
                      className='svg-icon-3 me-1'
                    />{' '}
                    {labelKey.previous}
                  </button>
                </div>
                <div>
                  <button
                    type='submit'
                    className='btn btn-lg btn-primary'
                    data-kt-stepper-action='submit'
                    disabled={updateIsLoading}
                  >
                    {!updateIsLoading && <span className='indicator-label'>{labelKey.submit} <KTSVG
                      path='/media/icons/duotune/arrows/arr064.svg'
                      className='svg-icon-3 ms-2 me-0'
                    /></span>}
                    {updateIsLoading && (
                      <span className='indicator-progress' style={{ display: 'block' }}>
                        {labelKey.pleaseWait}...{' '}
                        <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                      </span>
                    )}
                  </button>
                  <button
                    type='button'
                    className='btn btn-lg btn-primary'
                    data-kt-stepper-action='next'
                    onClick={nextStep}
                  >
                    {labelKey.nextStep}{' '}
                    <KTSVG
                      path='/media/icons/duotune/arrows/arr064.svg'
                      className='svg-icon-3 ms-1 me-0'
                    />
                  </button>
                </div>
              </div>
              {/*end::Actions */}
            </form>
            {/*end::Form */}
          </div>
          {/*end::Content */}
        </div>
        {/* end::Stepper */}
      </div>
    </Modal>,
    modalsRoot
  )
}

export { UpdateUserModal }

